import request from '../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const fetchData = query => {  
    var list = request({
        url: 'comWxWorkConfig/selectPage.do',
        method: 'post',
        params: query
    }); 
    return list;
};
 


//启用-禁用 
export const changeStatus = query => {  
    var list = request({
        url: 'comWxWorkConfig/changeStatus.do',
        method: 'post',
        params: query
    }); 
    return list;
};

export const changeSure = query => {  
    var list = request({
        url: 'comWxWorkConfig/changeSure.do',
        method: 'post',
        params: query
    }); 
    return list;
};
 

export const fetchSelect = query => {  
    var list = request({
        url: 'comWxWorkConfig/getListFetch.do',
        method: 'post',
        params: query
    }); 
    return list;
};


//添加渠道信息
export const saveForm = query => {  
    var list = request({
        url: 'comWxWorkConfig/insert.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};

export const handDelete = query => {  
    var list = request({
        url: 'comWxWorkConfig/delete.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};

export const changeForm = query => {  
    var list = request({
        url: 'comWxWorkConfig/update.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};




 



